<i18n src="@/i18n/template/components/DiyTable.json"></i18n>
<script>
import draggable from 'vuedraggable'
import { Tag } from 'element-ui'
export default {
  inheritAttrs: false,
  name: 'DiyTable',
  components: { draggable, [Tag.name]: Tag },
  props: {
    /**
     * 排序字段配置列表，必须与el-table-column的prop属性值一致
     * 注意 opreate列也必须要有个prop属性值为operate， 否则会不显示
     * @type {string[]} sortKeys
     */
    sortKeys: {
      type: Array,
      default: () => []
    },
    /**
     * 排序参数列表，接口Api调用时需要， 使用sync绑定即可
     * @type {{field: string, direction: 'asc' | 'desc'}[]} sortParams
     */
    sortParams: {
      type: Array,
      default: () => []
    },
    version: Number
  },
  computed: {
    addSortList() {
      let addList = []
      let map = this.sortParams.reduce((acc, cur) => {
        acc[cur.field] = cur.direction
        return acc
      }, {})
      this.sortKeys.forEach(key => {
        if (!map[key]) {
          addList.push({ key, direction: 'asc' })
          addList.push({ key, direction: 'desc' })
        }
      })
      return addList
    },
    tableColumns() {
      return (this.$slots.default || []).filter(item => {
        if (item.componentOptions?.tag === 'el-table-column') {
          return true
        }
        if (!item.componentOptions?.propsData?.prop) {
          console.error("diy table's child el-table-column must have prop")
          return false
        }
        console.error('diy table only support el-table-column in children')
        return false
      })
    },
    tableColumnsMap() {
      const map = {}
      this.tableColumns.forEach(item => {
        map[item.componentOptions.propsData.prop] = item
      })
      return map
    },
    sortedTableColumns() {
      const map = this.tableColumnsMap
      const used = {}
      const ordered = []
      this.columnsSortKeys?.forEach(col => {
        // operate column always be the last one
        if (col.prop === 'operate') return
        const it = map[col.prop]
        if (it && !used[col.prop]) {
          ordered.push(col)
          used[col.prop] = true
        }
      })
      this.tableColumns.forEach(it => {
        const prop = it.componentOptions.propsData.prop
        const fixed = it.componentOptions.propsData.fixed
        if (!prop || used[prop]) return
        ordered.push({
          prop: prop,
          fixed: fixed
        })
        used[prop] = true
      })
      return ordered
    },
    value() {
      return this.tableColumns.map(item => item.componentOptions.propsData)
    }
  },
  data() {
    const columnsSortKeys = this.getCacheData()
    return {
      updateTrigger: true,
      visible: false,
      columnsSortKeys: columnsSortKeys,
      inner: []
    }
  },
  render(h) {
    return h('div', [
      h(
        'div',
        {
          class: 'diy-table-column'
        },
        [
          h(
            'div',
            {
              class: 'diy-table-sort'
            },
            this.sortKeys?.length > 0
              ? [
                  h(
                    'span',
                    {
                      class: 'sort-icon'
                    },
                    [
                      h('i', {
                        class: 'el-icon-sort'
                      }),
                      `${this.$t('SortBy')}:`
                    ]
                  ),
                  ...this.sortParams.map(item => {
                    const columnNode = this.tableColumnsMap[item.field]
                    return h(
                      'span',
                      {
                        props: {
                          key: item.field
                        },
                        class: {
                          'sort-item': true,
                          desc: item.direction === 'desc'
                        },
                        on: {
                          click: () => this.handleSortClick(item)
                        }
                      },
                      [
                        h('i', {
                          class:
                            item.direction === 'asc'
                              ? 'el-icon-sort-up'
                              : 'el-icon-sort-down'
                        }),
                        columnNode?.componentOptions.propsData.label,
                        h(
                          'span',
                          {
                            class: 'remove-sort',
                            on: {
                              click: event => {
                                event.stopPropagation()
                                this.handleSortRemoveClick(item)
                              }
                            }
                          },
                          [
                            h('i', {
                              class: 'el-icon-error'
                            })
                          ]
                        )
                      ]
                    )
                  }),
                  this.addSortList.length > 0
                    ? h(
                        'el-dropdown',
                        {
                          props: {
                            placement: 'bottom-start'
                          },
                          on: {
                            command: this.handleAddSortClick
                          }
                        },
                        [
                          h(
                            'span',
                            {
                              class: 'add-sort'
                            },
                            [
                              h('i', {
                                class: 'el-icon-plus'
                              }),
                              this.$t('Add')
                            ]
                          ),
                          h(
                            'el-dropdown-menu',
                            {
                              slot: 'dropdown'
                            },
                            this.addSortList.map(addItem => {
                              const columnNode =
                                this.tableColumnsMap[addItem.key]
                              return h(
                                'el-dropdown-item',
                                {
                                  props: {
                                    command: `${addItem.key}#${addItem.direction}`
                                  },
                                  style: {
                                    color:
                                      addItem.direction === 'asc'
                                        ? '#67c23a'
                                        : '#409EFF'
                                  }
                                },
                                [
                                  h('i', {
                                    class:
                                      addItem.direction === 'asc'
                                        ? 'el-icon-sort-up'
                                        : 'el-icon-sort-down'
                                  }),
                                  columnNode?.componentOptions.propsData.label,
                                  ` (${addItem.direction.toUpperCase()})`
                                ]
                              )
                            })
                          )
                        ]
                      )
                    : null
                ]
              : []
          ),
          h(
            'span',
            {
              class: 'setting-button',
              on: {
                click: () => this.open()
              }
            },
            [
              h('i', {
                class: 'el-icon-setting'
              }),
              'Column Settings'
            ]
          )
        ]
      ),
      h(
        'el-table',
        {
          props: {
            data: this.$attrs.data
          },
          attrs: this.$attrs,
          on: this.$listeners,
          ref: 'table'
        },
        this.sortedTableColumns.map(item => {
          if (!this.updateTrigger) {
            return null
          }
          const node = this.tableColumnsMap[item.prop]
          return h(
            'el-table-column',
            {
              attrs: node.data?.attrs,
              props: {
                ...node.componentOptions.propsData,
                fixed: item.fixed,
                key: item.prop
              },
              class: node.data?.class || node.data?.staticClass,
              style: node.data?.style || node.data?.staticStyle,
              directives: node.data?.directives,
              scopedSlots: node.data?.scopedSlots
            },
            node.componentOptions.children
          )
        })
      ),
      h(
        'el-dialog',
        {
          props: {
            'append-to-body': true,
            'close-on-click-modal': true,
            title: this.$t('ColumnSettings'),
            width: '600px',
            visible: this.visible
          },
          on: {
            'update:visible': val => {
              this.visible = val
            }
          }
        },
        [
          h('div', { class: 'settings-body' }, [
            h(
              'draggable',
              {
                class: 'draggable-list',
                props: {
                  value: this.inner,
                  options: {
                    animation: 150,
                    handle: '.item-title'
                  }
                },
                on: {
                  input: val => {
                    this.inner = val
                  },
                  end: this.onDragEnd
                }
              },
              [
                h(
                  'transition-group',
                  this.inner.map(item =>
                    h(
                      'div',
                      {
                        class: {
                          'draggable-item': true,
                          'fixed-left': item.fixed
                        },
                        key: item.prop
                      },
                      [
                        h(
                          'div',
                          {
                            class: 'item-title'
                          },
                          [
                            h(
                              'span',
                              {
                                class: 'item-icon'
                              },
                              '≡'
                            ),
                            h('span', {}, item.label)
                          ]
                        ),
                        h(
                          'el-checkbox',
                          {
                            props: {
                              value: item.fixed,
                              size: 'mini'
                            },
                            on: {
                              input: val => this.handleFixedChange(val, item)
                            }
                          },
                          'Fixed on Left'
                        )
                      ]
                    )
                  )
                )
              ]
            )
          ]),
          h(
            'div',
            {
              class: 'dialog-footer',
              slot: 'footer'
            },
            [
              h(
                'el-button',
                {
                  on: {
                    click: () => {
                      this.visible = false
                    }
                  }
                },
                this.$t('cancel')
              ),
              h(
                'el-button',
                {
                  props: {
                    type: 'primary'
                  },
                  on: {
                    click: this.apply
                  }
                },
                this.$t('Apply')
              )
            ]
          )
        ]
      )
    ])
  },
  methods: {
    handleSortClick(item) {
      const sortParams = this.sortParams.map(i => {
        if (i.field === item.field) {
          return {
            ...i,
            direction: i.direction === 'asc' ? 'desc' : 'asc'
          }
        }
        return i
      })
      this.$emit('update:sortParams', sortParams)
      this.$emit('sort-change', sortParams)
    },
    handleSortRemoveClick(item) {
      const sortParams = this.sortParams.filter(i => i.field !== item.field)
      this.$emit('update:sortParams', sortParams)
      this.$emit('sort-change', sortParams)
    },
    handleAddSortClick(command) {
      const [key, direction] = command.split('#')
      const sortParams = [...this.sortParams, { field: key, direction }]
      this.$emit('update:sortParams', sortParams)
      this.$emit('sort-change', sortParams)
    },
    getStorageKey() {
      let key = this.$parent?.$options?.name
      if (!key) {
        console.error(
          'DiyTableColumn的父组件必须有name属性!!',
          '\nDiyTableColumn must be used in a named component'
        )
        return
      }
      return `diy-column-${key}-${this.version || 0}`
    },
    getCacheData() {
      let sortKeys = []
      let key = this.getStorageKey()
      if (!key) return sortKeys
      let data = localStorage.getItem(key)
      if (!data) return sortKeys
      try {
        sortKeys = JSON.parse(data)
      } catch (e) {}
      return sortKeys
    },
    saveCache(out) {
      let key = this.getStorageKey()
      if (!key) return
      const order = out.map(i => {
        return {
          prop: i.prop,
          fixed: i.fixed
        }
      })
      try {
        localStorage.setItem(key, JSON.stringify(order))
      } catch (e) {}
    },
    open() {
      this.reset()
      this.visible = true
    },
    reset() {
      let inner = []
      for (let i of this.sortedTableColumns) {
        // 操作列和已右固定列不参与排序
        if (i.prop === 'operate' || i.fixed === 'right') continue
        inner.push({
          ...i,
          fixed: i.fixed === 'left',
          label: this.tableColumnsMap[i.prop]?.componentOptions.propsData.label
        })
      }
      this.inner = inner
    },
    apply() {
      const columnsSortKeys = this.inner.map(i => ({
        prop: i.prop,
        fixed: i.fixed ? 'left' : undefined
      }))
      this.columnsSortKeys = columnsSortKeys
      this.saveCache(columnsSortKeys)
      this.$emit('column-sort-change', columnsSortKeys)
      this.visible = false
      this.updateTrigger = false
      this.$nextTick(() => {
        this.updateTrigger = true
        this.$refs.table.doLayout()
      })
    },
    handleFixedChange(val, item) {
      const left = []
      const normal = []
      this.inner.forEach(i => {
        if (i.prop === item.prop) {
          i.fixed = val
        }
        if (i.fixed) left.push(i)
        else normal.push(i)
      })
      this.inner = [...left, ...normal]
    },
    onDragEnd(evt) {
      const { newIndex } = evt
      const current = this.inner[newIndex]
      const prev = this.inner[newIndex - 1]
      const next = this.inner[newIndex + 1]

      // 1. 当拖拽到fixed属性为Left的item之前时，将当前拖拽对象的fixed属性设置为Left
      if (next && next.fixed) {
        current.fixed = true
      }
      // 2. 当拖拽的item的fixed属性Left且拖拽到fixed属性为None的item之后时，将当前拖拽对象的fixed属性设置为None
      else if (current.fixed && prev && !prev.fixed) {
        current.fixed = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.diy-table-column {
  margin: 10px 0 4px;
  display: flex;
  align-items: center;
  .diy-table-sort {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 24px;
    gap: 10px;
    flex: 1;
    margin-right: 10px;
    font-size: 12px;
    color: #666;
    .sort-item {
      position: relative;
      color: #67c23a;
      background-color: #f0f9eb;
      border: 1px solid #e1f3d8;
      border-radius: 4px;
      padding: 0 10px;
      padding: 2px 4px;
      border-radius: 4px;
      cursor: pointer;
      &.desc {
        color: #409eff;
        background-color: #ecf5ff;
        border-color: #d9ecff;
      }
      > i {
        font-weight: bold;
      }
      &:hover > i {
        color: red;
      }
    }
    .add-sort {
      cursor: pointer;
      font-size: 12px;
      color: $--color-primary;
    }
    .remove-sort {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      cursor: pointer;
      font-size: 14px;
      color: #c8cacd;
      &:hover {
        color: $--color-danger;
      }
    }
  }
  .setting-button {
    cursor: pointer;
    font-size: 12px;
    color: #666;
  }
}
.draggable-list {
  max-height: 520px;
  overflow-y: auto;
}
.draggable-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  margin-bottom: 8px;
  background: #fff;
  &.fixed-left {
    background: #e6f7ff;
    border-color: #91d5ff;
  }
}
.item-icon {
  display: inline-block;
  padding-right: 10px;
  color: #999;
}
.item-title {
  flex: 1;
  cursor: grab;
  font-size: 14px;
  color: #333;
}
</style>
